export default "__VITE_ASSET__bUDoO0EQ__"